import { Autocomplete, TextField } from '@mui/material';
import { FC } from 'react';
import { DateFilterVariant } from 'api/models/Filtering';
import theme from 'App.theme';

import { useLanguage } from 'context/AppContext';
import { FiltersMenuInputBox } from '../SearchFilters.styles';
import { FilterId, Lists } from '../types';
import DateFilter from './DateFilter';

type TFiltersMenuInput = FC<{
  activeMenuItem: FilterId;
  activeValue?: string;
  lists: Lists;
  onChange: (id: FilterId, val: string) => void;
}>;

const FiltersMenuInput: TFiltersMenuInput = ({ activeMenuItem, activeValue, lists, onChange }) => {
  const [lang] = useLanguage();

  return (
    <FiltersMenuInputBox>
      {activeMenuItem == 'surgeryDate' ? (
        // surgeryDate
        <DateFilter activeValue={activeValue} onChange={event => onChange(DateFilterVariant.surgeryDate, event)} />
      ) : activeMenuItem == 'dueDate' ? (
        // dueDate
        <DateFilter activeValue={activeValue} onChange={event => onChange(DateFilterVariant.dueDate, event)} />
      ) : activeMenuItem == 'supplier' ||
        activeMenuItem == 'surgeon' ||
        activeMenuItem == 'status' ||
        activeMenuItem == 'turnaroundStage' ||
        activeMenuItem == 'contents' ? (
        // supplier or surgeon or status
        <Autocomplete
          disablePortal
          open
          options={lists[activeMenuItem]}
          value={activeValue || undefined}
          sx={{ p: theme.layout.spacing.small }}
          renderInput={params => (
            <TextField
              {...params}
              label={lang.DeliveryListPage.table[activeMenuItem]}
              inputRef={input => input && input.focus()}
              size="small"
              sx={{ width: 300 }}
            />
          )}
          onChange={(_e, val) => onChange(activeMenuItem, val || '')}
        />
      ) : // unsupported activeMenuItem
      null}
    </FiltersMenuInputBox>
  );
};

export default FiltersMenuInput;
